import React, { useState, useEffect } from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import CardHeader from 'components/Card/CardHeader';
import { ArrowDropDown } from '@material-ui/icons';
import FilterArticle from 'hooks/FilterArticle';
import { Collapse } from '@material-ui/core';
import { wsCreate } from 'services/WService';
import Card from 'components/Card/Card';

function AddComboModal(props) {
  const { showNotify, reload, promotion } = props;

  const combo = props.model;

  const [checkDisplay, setCheckDisplay] = useState(true);
  const [nameArticle, setNameArticle] = useState('');
  const [dataChanging, setDataChanging] = useState({});

  function setOpen() {
    props.setOpen({ open: false });
  }

  async function onSave(data) {
    let res = await wsCreate(`prom/promotion/${promotion.id}/combo`, dataChanging);
    if (res.success) {
      showNotify(res.message);
      reload();
    } else {
      showNotify(res.message, 'error');
    }
  }

  return (
    <Modal
      title="Agregar Combo"
      model={props.model}
      setOpen={setOpen}
      showNotify={showNotify}
      entity={''}
      onSubmit={onSave}
    >
      <Card style={{ margin: 0, marginTop: '20px' }}>
        <CardHeader
          style={{ cursor: 'pointer', alignItems: 'center' }}
          onClick={() => {
            setCheckDisplay((prev) => !prev);
          }}
          icon
        >
          <h4
            style={{
              color: 'black',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-end',
            }}
          >
            {nameArticle === '' ? 'Selecciona producto' : nameArticle}
            <ArrowDropDown />
          </h4>
        </CardHeader>
        <Collapse in={checkDisplay} key={1}>
          <div
            elevation={4}
            style={{
              padding: '10px',
              margin: 'auto',
              marginBottom: '8px !important',
              width: '100%',
            }}
          >
            <FilterArticle
              productFilter={{
                base_business_partner_id: combo.base_business_partner_id,
                combo_type: 'D',
              }}
              fullWidth={true}
              article
              setNameArticle={setNameArticle}
              setDataChanging={setDataChanging}
              dataChanging={dataChanging}
              required
            />
          </div>
        </Collapse>
      </Card>
    </Modal>
  );
}

export default AddComboModal;
